import dayjs from 'dayjs'

/**
 * @returns The cache key for the invoice form. Is unique for each business and valid for the current day.
 */
export const invoiceFormCacheKey = (slug: string) => {
  return `${slug}.invoiceForm.new.${dayjs().format('YYYY-MM-DD')}`
}
